const initailState = {
    arr:[],
}

const Urldata=(state=initailState,action)=>{
    switch(action.type){
        case 'ADD_urlDATA':
            return{ 
                ...state,
                arr: state.arr.concat(action.payload),
            }
        default:
            return state;
    }
}

export default Urldata